import journal from '@/api/journal'
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { statisticSpecial } from '@/api/statistic'
import help from '@/utils/help'

const columns = [
  {
    title: '',
    enTitle: 'Title',
    width: 500,
    dataIndex: 'titleText',
    slot: 'title'
  },
  {
    title: '',
    enTitle: 'View',
    width: 100,
    dataIndex: 'readNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Published Papers',
    width: 150,
    dataIndex: 'articleNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Planned Papers',
    width: 150,
    dataIndex: 'particleNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'View for Papers',
    width: 150,
    dataIndex: 'summaryNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Download',
    width: 100,
    dataIndex: 'pdfDownloadNum',
    sort: true
  }
]
export default {
  components: {
    SiteSearchGroup
  },
  data() {
    return {
      params: {},
      journalList: [],
      startDate: [],
      endDate: [],
      showAdv: false,
      status: '',
      loading: false,
      columns: columns,
      dataSource: [],
      titleTab: [
        { title: 'Special Issue Statistics', statu: 1 }
        // { title: 'Manuscript Statistics', statu: 2 }
        // { title: 'Draft', statu: 3 }
      ],
      titleStatu: 1,
      staticTime: '',
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser',
      journalId: 'getJournalId'
    })
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
      },
      immediate: true
    }
  },
  mounted() {
    this.getJournalList()
    help.closeAutocomplete()
  },
  methods: {
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      this.journalList.unshift({
        name: 'All',
        journalId: '',
        id: ''
      })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const {
        list,
        pageIndex,
        pageSize,
        total,
        updateTime
      } = await statisticSpecial.get(data)
      this.dataSource = list
      this.staticTime = updateTime

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    changeStatus(val) {
      this.titleStatu = val.statu
      this.getList()
    },
    changeJournal(val) {
      this.getList()
      localStorage.setItem('journalId', val)
    },
    handleDateChange(date, val) {
      this.params['start' + val] = date[0] ? date[0].startOf('d') : ''
      this.params['end' + val] = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    async exp() {
      this.loading = true
      try {
        const res = await statisticSpecial.export(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    },

    handleClear() {
      this.params.keyword = ''
      this.status = ''
      this.startDate = []
      this.endDate = []
      this.getList()
    },
    async detail(val) {
      let url = `/journal/${val.journalName}/test/special/${
        val.specialId
      }?token=${localStorage.getItem('token')}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.5.18:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.4.35:3020' + url
      }
      // window.open(url, '', 'width=60%,height=40%,left=200,right=200')
      window.open(url)
    }
  }
}
